$(document).ready(function() {
    $('.photo').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    $('.lazy').show().lazy();

    /* START menu for tablets and mobiles */
    $("#header a.mobile-btn").click(function() {
        if($('#header .nav').hasClass('active')){
            $('#header .nav').removeClass('active');
            $(this).removeClass('active');
            $(this).find('i.icon').addClass('icon-menu').removeClass('icon-close');
        }else{
            $('#header .nav').addClass('active');
            $(this).addClass('active');
            $(this).find('i.icon').removeClass('icon-menu').addClass('icon-close');
        }
    });

    var owl = $('.owl-carousel');

    owl.owlCarousel({
        loop: true,
        margin: 0,
        dots:true,
        nav: false,
        items: 1,
        autoplay: true,
        autoplayTimeout: 7000,
        animateIn: "fadeIn"
    });



    $(".jslink").click(function(){
        window.location=$(this).find("a").attr("href");
        return false;
    });

    $('input[name="company"]').click(function(){
        if($(this).is(':checked')){
            $('#companyInfo').addClass('active');
        }else{
            $('#companyInfo').removeClass('active');
        }
    });

});
